export default __webpack_public_path__ + "static/media/Resume.3ba461e9.pdf";